export function isTabletDevice(): boolean {
  const ua = navigator.userAgent;

  if (/iPad/i.test(ua)) return true;

  // iPadOS 13+ se identifica como Mac con pantalla táctil
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) return true;

  // Tablets Android (sin "Mobile" en el user agent)
  if (/Android/i.test(ua) && !/Mobile/i.test(ua)) return true;

  return false;
}
